import axios from 'axios'
import Cookies from 'js-cookie' 
import setLocalStorage from '../utils/setLocalStorage.js'
 //刷新请求token
export function axiosTimer(refreshToken){
    let isLoad=false 
	let nowTimer=new Date().getTime()
    let cookTimer = window.localStorage.getItem("cookieTimer")||Cookies.get('cookieTimer')||0; 
    let msec = nowTimer - cookTimer;  
    // 计算时分秒数  
    let min = parseInt(msec / 1000 / 60 % 60) ; 
	if(min>=23){
		// console.log('====重新请求======')
		window.localStorage.setItem("cookieTimer",nowTimer);
        Cookies.set('cookieTimer',nowTimer)
        if(isLoad) return
        isLoad = true;
        axios.get(`/refreshToken?refreshToken=${refreshToken}`).then(res=>{ 
            let data = res.data; 
            if (data && data.code == 0) {
                //和login2页面存储的值保持一致
                setLocalStorage(data)
               //保持和修改登录之前数据一样 
                Cookies.set('yianInfo', JSON.stringify (data) , { expires: 1 }); 
            }else{ 
                console.log(res.msg||'刷新token失败～')
            }
            isLoad = false;
        })
	} 
	// let sec = parseInt(msec / 1000 % 60) 
    // 控制台打印 
    // console.log( `${min}分钟  `,msec,sec) 
} 